import '@/compiled-icons/file-pdf-outline';
import '@/compiled-icons/microsoft-excel';
import '@/compiled-icons/microsoft-word';
import '@/compiled-icons/microsoft-powerpoint';
import '@/compiled-icons/image-outline';
import '@/compiled-icons/file-outline';
import '@/compiled-icons/video-outline';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {set} from 'lodash';

class ParamsUtils {

    convertParamListToCompositeKey(
        urlParameters: DisguiseDto.DTUrlParameterDto[] | undefined
    ): CompositeKeyType {

        const result: CompositeKeyType = {};

        for (const currentActionParam of urlParameters || []) {
            const paramName = currentActionParam.parameter;
            if (paramName !== undefined) {
                set(result, paramName, currentActionParam.value || '');
            }
        }

        return result;

    }
}

const AMETRAS_PARAM_UTILS = new ParamsUtils();

export {AMETRAS_PARAM_UTILS};

